import { render } from "./ModalInfo.vue?vue&type=template&id=e5f1870c&scoped=true"
import script from "./ModalInfo.vue?vue&type=script&lang=js"
export * from "./ModalInfo.vue?vue&type=script&lang=js"

import "./ModalInfo.vue?vue&type=style&index=0&id=e5f1870c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f1870c"]])

export default __exports__